import React, { Fragment } from "react";
import styled from "styled-components";
import { Col } from "reactstrap";
import { pathOr } from "ramda";

import Label from "../../../FormFields/Label";

export const FileNameOrUpload = ({ file }) => {
  if (file && file.name) {
    return file.name;
  } else {
    return (
      <Fragment>
        <i className="fa fa-arrow-up" /> Upload
      </Fragment>
    );
  }
};

export const uploadFile = async ({
  url,
  formData,
  dispatch,
  setUploadingFile,
  fetch = window.fetch,
}) => {
  return fetch(url, {
    method: "POST",
    body: formData,
  })
    .then(({ ok, statusText }) => {
      if (!ok) {
        dispatch({
          type: "onFileChangeCancel",
          key: "attachments",
          value: null,
          error:
            "There was an issue uploading the document file. Please try again.",
        });
      }
    })
    .catch((e) => {
      dispatch({
        type: "onFileChangeCancel",
        key: "attachments",
        value: null,
        error:
          "There was an issue uploading the document file. Please try again.",
      });
    })
    .finally(() => setUploadingFile(false));
};

const UploadForm = styled.label`
  border: 1px dashed ${(props) => props.theme.colors.gray};
  padding: 13px;
  text-align: center;
  color: ${(props) => props.theme.primaryLinkColor};
  width: 100%;
  &:hover {
    cursor: pointer;
  }
  input[type="file"] {
    display: none;
  }
`;

const FileLabel = styled.label`
  font-size: 12px;
  font-weight: 700;
  font-family: ${(props) => props.theme.fonts.heading};
  text-transform: uppercase;
`;

const submissionTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/rtf",
].join(",");

export default class UploadResume extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resume: null,
      coverLetter: null,
    };
    this.makeFormData = this.makeFormData.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  async makeFormData(name, file, setUploadingFile, dispatch) {
    const { fields, jobId, url } = this.props;
    dispatch({
      type: "onJobLoad",
      value: jobId,
    });
    const formData = new FormData(); // eslint-disable-line
    formData.append("key", fields.key);
    formData.append("X-Amz-Credential", fields.credential);
    formData.append("X-Amz-Algorithm", fields.algorithm);
    formData.append("X-Amz-Date", fields.date);
    formData.append("Policy", fields.policy);
    formData.append("X-Amz-Signature", fields.signature);
    formData.append("X-Amz-Security-Token", fields.securityToken);
    formData.append("file", file);
    setUploadingFile(true);

    await uploadFile({ url, formData, dispatch, setUploadingFile });
  }

  onChange(e) {
    const { fields, dispatch, refetch, error, setUploadingFile } = this.props;
    const fileName =
      e.target.name === "cover_letter" ? "coverLetter" : e.target.name;
    this.setState({ [fileName]: e.target.files[0] });
    if (e.target.value) {
      dispatch(
        {
          type: "onFileChange",
          key: "attachments",
          value: {
            key: fields.key,
            filename: pathOr(null, ["target", "files", 0, "name"], e),
            type: e.target.name,
          },
          error: fileName === "resume" ? null : error,
        },
        () => refetch(),
      );
      this.makeFormData(
        e.target.name,
        e.target.files[0],
        setUploadingFile,
        dispatch,
      );
    } else {
      dispatch(
        {
          type: "onFileChangeCancel",
          key: "attachments",
          value: null,
          error: fileName === "resume" ? "Please upload a resume" : error,
        },
        () => refetch(),
      );
    }
  }

  render() {
    const { resume, coverLetter } = this.state;
    const { error } = this.props;

    return (
      <Fragment>
        <Col sm="6">
          <FileLabel>
            Resume <sup>*</sup>
          </FileLabel>
          <UploadForm type="file" name="file">
            <input
              type="file"
              name="resume"
              accept={submissionTypes}
              onChange={this.onChange}
            />
            <FileNameOrUpload file={resume} />
          </UploadForm>
          <Label error className="mb-4" weight="500">
            {error}
          </Label>
        </Col>
        <Col sm="6">
          <FileLabel>Cover Letter (optional)</FileLabel>
          <UploadForm type="file" name="submit">
            <input
              type="file"
              name="cover_letter"
              accept={submissionTypes}
              onChange={this.onChange}
            />
            <FileNameOrUpload file={coverLetter} />
          </UploadForm>
        </Col>
      </Fragment>
    );
  }
}
